import React from "react";
import {DayReport} from "@/data/entities/dayReport";
import {DescriptionList, DescriptionListItem, Spinner} from "peggirkit";
import {formatMoney} from "@/utils/MoneyUtils";
import {minutesToHhMm} from "@/utils/DateUtils";
import {FormattedMessage} from "react-intl";

type Props = {
    dayReport?: DayReport,
    isFetching: boolean,
};

const DayReportTable = ({dayReport, isFetching}: Props) => {

    if (isFetching || dayReport === undefined) {
        return <Spinner size={"lg"}/>;
    }

    const {minutes: workedMinutes, hours: workedHours} = minutesToHhMm(dayReport.workedMinutes)

    return (
        <DescriptionList>
            <DescriptionListItem title={"Dag"} content={new Date(dayReport.date).toLocaleDateString()}/>
            <DescriptionListItem title={"Bruto-omzet"} content={formatMoney(dayReport.grossRevenue)}/>
            <DescriptionListItem title={"Netto-omzet"} content={formatMoney(dayReport.netRevenue)}/>
            <DescriptionListItem title={"Totaal btw"} content={formatMoney(dayReport.vat)}/>
            <DescriptionListItem
                title={"Gewerkte minuten (hh:mm)"}
                content={
                    <FormattedMessage
                        id={"formattedHoursMinutes"}
                        values={{
                            hours: workedHours,
                            minutes: workedMinutes,
                        }}
                    />
                }
            />
            <DescriptionListItem title={"Online betaald"} content={dayReport.onlinePaidOrderCount}/>
            <DescriptionListItem title={"Aan de deur betaald"} content={dayReport.inPersonPaidOrderCount}/>
            <DescriptionListItem title={"Geannuleerd"} content={dayReport.cancelledOrderCount}/>
        </DescriptionList>
    );
};

export default DayReportTable;